export default __webpack_public_path__ + "static/media/12.5b0d09ca.jpg";